<template>
  <v-snackbar v-model="show" :color="color" :timeout="12000" top right>
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="show = false">
        Cerrar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Mensaje',

  data() {
    return {
      show: false,
      message: '',
      color: 'warning'
    }
  },

  methods: {
    open(message, color = 'warning') {
      this.message = message
      this.color = color
      this.show = true
    }
  }
}
</script>
